import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | Industrix Solution" description="The page you are looking for could not be found." path="/404" noindex />
      <section className="relative overflow-hidden" data-testid="not-found">
        <div className="grid-lines absolute inset-0" aria-hidden="true" />
        <div className="wrap relative py-28 lg:py-40">
          <p className="eyebrow">Error 404</p>
          <p className="mt-6 font-display text-[28vw] font-extrabold leading-none text-charcoal/10 sm:text-[12rem]" style={{ fontStretch: "125%" }} aria-hidden="true">404</p>
          <h1 className="-mt-6 text-4xl font-extrabold sm:text-5xl">This page is off the production line.</h1>
          <p className="lead mt-6 max-w-xl">The page may have moved or never existed. Try one of these instead.</p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link to="/" className="btn-primary" data-testid="404-home-btn">Back to home</Link>
            <Link to="/services" className="btn-ghost">Services</Link>
            <Link to="/contact" className="btn-ghost">Contact</Link>
          </div>
        </div>
      </section>
    </>
  );
}
